moduleViewApp.controller('editModuleCtrl', ['$scope', '$routeParams', 'CategoriesResource', 'LanguagesResource', 'SeriesResource', 'SetsResource', 'moduleContextService', ($scope, $routeParams, CategoriesResource, LanguagesResource, SeriesResource, SetsResource, moduleContextService) ->
  #debug
  window.debug = window.debug || {}
  window.debug["editModuleCtrl"] = $scope

  MAX_DESCRIPTION_CHAR = 1500

  _.assignIn $scope,
    module: {}
    dirty: false

    isLanguage: ->
      $scope.category.title == 'Languages'

    subCategoryText: ->
      if $scope.category && $scope.isLanguage()
        "js.module_view.edit_module.subcategory_language"
      else
        "js.module_view.edit_module.subcategory"

    contentLanguageText: ->
      if $scope.category && $scope.isLanguage()
        "js.module_view.edit_module.category_language"
      else
        "js.module_view.edit_module.category"

    saveText: ->
      if $scope.dirty
        "js.module_view.edit_module.saving"
      else
        "js.module_view.edit_module.save_changes"

    saveChanges: ->
      $scope.dirty = true

      params =
        id: $scope.module.id
        name: $scope.module.name
        description:   $scope.module.description_html
        category_id:   $scope.module.main_category && $scope.module.main_category.id
        subject_id:    $scope.module.subcategory && $scope.module.subcategory.id
        language_id:   $scope.module.language && $scope.module.language.id
        icon_image_id: $scope.module.image && $scope.module.image.id

      resource = if $scope.module.module_type == "set" then SetsResource else SeriesResource

      resource.update {}, params, (result) ->
        $scope.dirty = false

    fetchModule: ->
      if $routeParams.set_id
        type = "set"
        id = $routeParams.set_id
      else
        type = "series"
        id = $routeParams.series_id
      moduleContextService.fetchModule(id, type).then (module) ->
        $scope.module = module
        CategoriesResource.get {}, (success) ->
          $scope.categories = _.find(success.response, slug: 'content-categories').children
          if $scope.module.main_category
            $scope.module.main_category = _.find($scope.categories, id: $scope.module.main_category.id)
          if $scope.module.subcategory
            $scope.module.subcategory = _.find($scope.module.main_category.children, id: $scope.module.subcategory.id)

        LanguagesResource.query {}, (success) ->
          $scope.languages  = success.response
          if $scope.module.language
            $scope.module.language = _.find($scope.languages,id: $scope.module.language.id)

  $scope.$watch "module.description_html", ->
    $scope.module.description_html ||= ""
    $scope.characterLeft = MAX_DESCRIPTION_CHAR - $scope.module.description_html.length
    $scope.module.description_html = $scope.module.description_html.substring(0, MAX_DESCRIPTION_CHAR)

  $scope.fetchModule()
])
